export const HOME_ROUTE_PATH = "/";
export const ABOUT_ROUTE_PATH = "/about";
export const LOGIN_ROUTE_PATH = "/login";
export const REGISTER_ROUTE_PATH = "/register";
export const USER_PROFILE_ROUTE_PATH = "user/profile";
export const USER_SETTINGS_ROUTE_PATH = "user/settings";
export const EXPENSES_ROUTE_PATH = "/expenses";
export const INCOMES_ROUTE_PATH = "/incomes";
export const CATEGORIES_ROUTE_PATH = "/categories";
export const REPORTS_ROUTE_PATH = "/reports";
export const MONTHLY_REPORTS_ROUTE_PATH = REPORTS_ROUTE_PATH + "/monthly";
export const OVERALL_REPORTS_ROUTE_PATH = REPORTS_ROUTE_PATH + "/overall";
export const VERIFY_EMAIL_ROUTE_PATH = "/verify-email";
export const VERIFY_EMAIL_CONFIRM_ROUTE_PATH = "/email/verify";
export const FORGOT_PASSWORD_ROUTE_PATH = "/forgot-password";
export const RESET_PASSWORD_ROUTE_PATH = "/reset/password";
export const VERIFY_EMAIL_CHANGE_ROUTE_PATH = "/verify-email-change";
export const PROFILE_TAB_QUERY_PARAM = "tab";
export const PROFILE_TAB_PERSONAL = "personal";
export const PROFILE_TAB_SETTINGS = "settings";
export const PROFILE_TAB_SECURITY = "security";
export const PROFILE_TAB_FINANCIAL = "financial";
export const CONTACT_ROUTE_PATH = "/contact";
